import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface TenantConfigAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  tenant: OD3_Tenant;
  primaryColor?: string;
  secondaryColor?: string;
  contactText?: string;
  addressText?: string;
  openingHoursText?: string;
  mapLabel?: string;
  mapGeoPoint?: Parse.GeoPoint;
  routeDescriptionText?: string;
  logo?: Parse.File;
  menuItemUrl?: string;
  title?: string;
  contactEmail?: string;
  contactWeb?: string;
  contactPhone?: string;
  contactFax?: string;
  logoUrl?: string;
  menuItemLabel?: string;
  googleMaps?: string;
  imprintUrl?: string;
  tosUrl?: string;
  privacyUrl?: string;
  primaryTextColor?: string;
  secondaryTextColor?: string;
  frontpageBackgroundImage?: Parse.File;
  contactImage?: Parse.File;
  menuItemIcon?: string;
  frontpageGlossarIcon?: string;
  frontpageVideoIcon?: string;
  frontpageContactIcon?: string;
  contactWhatsappLabel?: string;
  contactWhatsappLink?: string;
  pageTitleInvoice?: string;
  pageTitleVideo?: string;
  pageTitleGlossary?: string;
  pageTitleContact?: string;
  menuItem2Url?: string;
  menuItem2Icon?: string;
  menuItem3Icon?: string;
  menuItem2Label?: string;
  menuItem3Label?: string;
  menuItem3Url?: string;
  forceHost?: string;
  imprintText?: string;
  privacyText?: string;
  tosText?: string;
  hideVideoIds?: string[];
}

export class TenantConfig extends Parse.Object<TenantConfigAttributes> {
  constructor(data?: Partial<TenantConfigAttributes>) {
    super("APP_TenantConfig", data as TenantConfigAttributes);
  }
}

Parse.Object.registerSubclass("APP_TenantConfig", TenantConfig);
